module.exports = __webpack_public_path__ + "img/user.caacd20b.svg";